import { COUNTRY_CODES } from "../../../constants/countries";

export const INVOICE_FORM_CONFIG = {
    [COUNTRY_CODES.ECUADOR]: {
        requiredFields: {
            colegio: true,
            cliente: true,
            alumno: false,
        },
        permissions: {
            createClient: true,
            canBuyIndividualBooks: true,
            canApplyGlobalDiscount: true,
            canApplyPriceIncrease: false,
        },
    },
    [COUNTRY_CODES.PARAGUAY]: {
        requiredFields: {
            colegio: false,
            cliente: false,
            alumno: false,
        },
        permissions: {
            createClient: true,
            canBuyIndividualBooks: true,
            canApplyGlobalDiscount: true,
            canApplyPriceIncrease: false,
        }
    },
    [COUNTRY_CODES.HONDURAS]: {
        requiredFields: {
            colegio: true,
            cliente: true,
            alumno: true,
            campaign: true,
        },
        permissions: {
            createClient: false,
            canBuyIndividualBooks: false,
            canApplyGlobalDiscount: true,
            canApplyPriceIncrease: false,
        }
    },
    [COUNTRY_CODES.ELSALVADOR]: {
        requiredFields: {
            colegio: true,
            cliente: true,
            alumno: true,
            campaign: true,
        },
        permissions: {
            createClient: false,
            canBuyIndividualBooks: false,
            canApplyGlobalDiscount: true,
            canApplyPriceIncrease: true,
        }
    },
};

export const getInvoiceFormConfig = (pais) => { return INVOICE_FORM_CONFIG[pais] || INVOICE_FORM_CONFIG[COUNTRY_CODES.ECUADOR]; };